import type { ReactNode } from 'react';

export type IncidentDetailMarkerFiltersProps = {
  children?: ReactNode;
};

export function IncidentDetailMarkerFilters({ children }: IncidentDetailMarkerFiltersProps) {
  if (children == null) {
    return null;
  }

  return (
    <div className="map-overlay-control d-flex flex-row align-items-center gap-1 rounded-3 bg-body border border-dark shadow px-2">
      {children}
    </div>
  );
}
